module.exports = "/static/assets/75b3b88fea61068b8aefdf24d7d75530.png";